var UtilMap = /** @class */ (function () {
    function UtilMap() {
    }
    UtilMap.prototype.toMap = function (array, idKey) {
        if (idKey === void 0) { idKey = "id"; }
        if (array == undefined) {
            return undefined;
        }
        return array.reduce(function (map, value) {
            map.set(value[idKey], value);
            return map;
        }, new Map());
    };
    return UtilMap;
}());
export var utilMap = new UtilMap();



//////////////////
// WEBPACK FOOTER
// ./src/utils/utilMap.ts
// module id = 1785
// module chunks = 3